<nav class="navbar navbar-dark bg-dark sticky-top flex-md-nowrap p-2 shadow">
	<div class="kiosk-navbar">
		<button *ngIf="this.authService.isVerified()" class="btn" type="button" (click)="open(content)">
			<span class="navbar-toggler-icon"></span>
		</button>
		<a class="navbar-brand col-md-3 col-lg-2 mr-0 px-3" href="#">Axon Kiosk Management</a>
		{{pageName}}
	</div>
	<div>
		<div class="row float-right kiosk-nav-link">
			<div *ngIf="this.authService.isVerified()" class="col link">
				<fa-icon class="text-secondary" [icon]="profile"></fa-icon>&nbsp;<a  class="nav-link text-secondary" [routerLink]="['/kiosk','profile']">{{username}}</a>
			</div>
			<div class="col link">
				<fa-icon [icon]="signOut"></fa-icon>&nbsp;<a class="nav-link" [routerLink]="['/']" (click)="authService.signOut()">Sign out</a>
			</div>
		</div>
	</div>
</nav>

<ng-template #content let-offcanvas>
	<div class="offcanvas-header">
		<h4 class="offcanvas-title" id="offcanvas-basic-title">Menu</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
		<ng-container *ngFor="let pageGroup of pageGroups"> <!--let pageGroup of pageGroups | async-->
			<h6
				class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase">
				<span>{{pageGroup.title}}</span>
			</h6>

			<ul *ngFor="let page of pageGroup.pages" class="nav flex-column mb-2">
				<li class="nav-item">
					<a [routerLink]="['/kiosk',page.path]" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="page.icon"></fa-icon>
						{{page.name}}
					</a>
				</li>
			</ul>
		</ng-container>




		<!-- <ng-container *ngIf="isEnabled('Kiosk')">
			<h6
				class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase">
				<span>Kiosk</span>
			</h6>
			<ul class="nav flex-column mb-2">
				<li class="nav-item">
					<a [routerLink]="['/kiosk','list']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="faLayerGroup"></fa-icon>
						All Kiosks
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/kiosk','problems']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="problem"></fa-icon>
						Problem Kiosks
					</a>
				</li>
			</ul>
			<h6
				class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase">
				<span>Administration</span>
			</h6>
			<ul class="nav flex-column mb-2">
				<li class="nav-item">
					<a [routerLink]="['/kiosk','add-admin']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="addAdmin"></fa-icon>
						Add Admin
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/kiosk','admins']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="allAdmins"></fa-icon>
						Admins
					</a>
				</li>
			</ul>
			<h6
				class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase">
				<span>Technicians</span>
			</h6>
			<ul class="nav flex-column mb-2">
				<li class="nav-item">
					<a [routerLink]="['/kiosk','add-technician']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="addTech"></fa-icon>
						Add Technician
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/kiosk','technicians']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="allTechs"></fa-icon>
						Technicians
					</a>
				</li>
			</ul>
			<h6
				class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted text-uppercase">
				<span>Locations</span>
			</h6>
			<ul class="nav flex-column mb-2">
				<li class="nav-item">
					<a [routerLink]="['/kiosk','add-location']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="addLocation"></fa-icon>
						Add Location
					</a>
				</li>
				<li class="nav-item">
					<a [routerLink]="['/kiosk','locations']" [routerLinkActive]="['active']" class="nav-link" (click)="offcanvas.dismiss('Cross click')">
						<fa-icon [icon]="allLocations"></fa-icon>
						Locations
					</a>
				</li>
			</ul>
		</ng-container> -->
	</div>
</ng-template>